import {
  FETCH_CUSTOMERS,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAIL,
  SET_CUSTOMER_IN_VIEW,
  SET_STROMBOLI_ON_SUCCESS,
  DANGER,
  FETCH_TARGETS_SUCCESS,
  FETCH_VECTORS_SUCCESS,
  FETCH_VECTORS,
  FETCH_VECTORS_FAIL,
  FETCH_TARGET_SUCCESS,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAIL,
  FETCH_EVENTS,
  FETCH_ATTACKS_SUCCESS,
  FETCH_CAMPAIGNS_SUCCESS,
  FETCH_CAMPAIGNS_FAIL,
  FETCH_CAMPAIGNS,
  FETCH_PERIMETER_ATTACKS_META,
  FETCH_PERIMETER_ATTACKS_META_SUCCESS,
  FETCH_PERIMETER_ATTACKS_META_FAIL,
  FETCH_ATTACKS_FAIL,
  FETCH_ATTACKS,
  FETCH_ATTACK_FAIL,
  FETCH_ATTACK_SUCCESS,
  FETCH_ATTACK,
  ADD_CUSTOMER,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAIL,
  SUCCESS,
  SET_TARGET_SCOPE,
  SET_TARGET_SCOPE_SUCCESS,
  SET_TARGET_SCOPE_FAIL,
  CUSTOMER_MODULE_ACTIVATE,
  CUSTOMER_MODULE_ACTIVATE_SUCCESS,
  CUSTOMER_MODULE_ACTIVATE_FAIL,
  CUSTOMER_MODULE_DEACTIVATE_FAIL,
  CUSTOMER_MODULE_DEACTIVATE_SUCCESS,
  CUSTOMER_MODULE_DEACTIVATE,
  CUSTOMER_SUBSCRIPTION_ACTIVATE,
  CUSTOMER_SUBSCRIPTION_ACTIVATE_SUCCESS,
  CUSTOMER_SUBSCRIPTION_ACTIVATE_FAIL,
  CUSTOMER_SUBSCRIPTION_DEACTIVATE,
  CUSTOMER_SUBSCRIPTION_DEACTIVATE_SUCCESS,
  CUSTOMER_SUBSCRIPTION_DEACTIVATE_FAIL,
  ADD_BR_SUBSCRIPTION,
  ADD_BR_SUBSCRIPTION_SUCCESS,
  ADD_BR_SUBSCRIPTION_FAIL,
  UPDATE_BR_SUBSCRIPTION,
  UPDATE_BR_SUBSCRIPTION_SUCCESS,
  UPDATE_BR_SUBSCRIPTION_FAIL,
  ADD_TAG_CUSTOMER_SUCCESS,
  ADD_TAG_CUSTOMER_FAIL,
  UPDATE_TAG_CUSTOMER_SUCCESS,
  UPDATE_TAG_CUSTOMER_FAIL,
  FETCH_BR_SUBSCRIPTION,
  FETCH_BR_SUBSCRIPTION_SUCCESS,
  FETCH_BR_SUBSCRIPTION_FAIL,
  FETCH_USERS_FOR_CUSTOMER,
  FETCH_USERS_FOR_CUSTOMER_SUCCESS,
  FETCH_USERS_FOR_CUSTOMER_FAIL,
  CREATE_USER_FOR_CUSTOMER,
  CREATE_USER_FOR_CUSTOMER_SUCCESS,
  CREATE_USER_FOR_CUSTOMER_FAIL,
  DELETE_USER_FOR_CUSTOMER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FOR_CUSTOMER_SUCCESS,
  DELETE_USER_FOR_CUSTOMER_FAIL,
  DELETE_USER_FOR_CUSTOMER_INVITE,
  DELETE_USER_FOR_CUSTOMER_INVITE_SUCCESS,
  DELETE_USER_FOR_CUSTOMER_INVITE_FAIL,
  UPDATE_CUSTOMER_NAME,
  UPDATE_CUSTOMER_NAME_SUCCESS, UPDATE_CUSTOMER_NAME_FAIL
} from "constants/ActionTypes";
import {
  CUSTOMER_REINIT_STATE, FETCH_HUMANS, FETCH_HUMANS_FAIL, FETCH_HUMANS_SUCCESS, FETCH_TARGETS, FETCH_TARGETS_FAIL,
  SET_STROMBOLI_OFF,
  SET_STROMBOLI_OFF_FAIL,
  SET_STROMBOLI_OFF_SUCCESS,
  SET_STROMBOLI_ON,
  SET_STROMBOLI_ON_FAIL
} from "../constants/ActionTypes";
import {filterObject, showBBNotification} from "../util/bbHelpers";

const INIT_STATE = {
  customers: null,
  loadingCustomers: false,
  loadingCustomersError: false,
  addingCustomerError: false,
  loadingTargets: false,
  loadingTargetsError: false,
  loadingHumans: false,
  loadingHumansError: false,
  loadingVectors: false,
  loadingVectorsError: false,
  loadingCampaigns: false,
  loadingCampaignsError: false,
  customerInView: null, //the id number of the customer currently being viewed.  can be set by the URL or by an aciton.
  loadingStromboli: false,
  loadingStromboliError: false,
  loadingEvents: false,
  loadingEventsError: false,
  metaTargets: null,
  metaEvents: null,
  loadingAttacks: false,
  loadingAttacksError: false,
  loadingAttack: false,
  loadingAttackError: false,
  metaAttacks: null,
  loadingMetaAttacks: false,
  loadingMetaAttacksError: false,
  metaCampaigns: null,
  metaVectors: null,
  scopeTogglesLoading: {},
  scopeTogglesFail: {},
  loadingCustomerModuleActivate: {},
  loadingCustomerModuleActivateFail: {},
  loadingCustomerModuleDeactivate: {},
  loadingCustomerModuleDeactivateFail: {},
  loadingCustomerSubscriptionActivate: {},
  loadingCustomerSubscriptionActivateFail: {},
  loadingCustomerSubscriptionDeactivate: {},
  loadingCustomerSubscriptionDeactivateFail: {},
  loadingAddBRSubscription: {},
  loadingAddBRSubscriptionError: {},
  loadingUpdateBRSubscription: {},
  loadingUpdateBRSubscriptionError: {},
  loadingSubscriptions: false,
  errorLoadingSubscriptions: false,
  // usersForCustomer: null,
  loadingUsersForCustomer: {},
  loadingUsersForCustomerError: {},
  loadingCreateUserForCustomer: {},
  loadingCreateUserForCustomerError: {},
  loadingDeleteUserForCustomer: {},
  loadingDeleteUserForCustomerError: {},
  loadingUpdateCustomerName: {},
  loadingUpdateCustomerNameError: {},
  appMisc: {
    didJustCreateNewBRSubscription: null,
    didJustUpdateBRSubscription: null,
    didJustAddUser: null,
    didJustDeleteUser: null,
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

  /***********************************
   * Non API Calls
   ***********************************/

    case SET_CUSTOMER_IN_VIEW: {
      return {
        ...state,
        customerInView: action.payload
      }
    }

    case CUSTOMER_REINIT_STATE: {
      // console.log("Received action CUSTOMER_REINIT_STATE Returning INIT_STATE.");
      return {
        ...INIT_STATE,
      }
    }

    /***********************************
     * FETCH_CUSTOMERS
     ***********************************/

    case FETCH_CUSTOMERS: {
      return {
        ...state,
        loadingCustomers: true,
        loadingCustomersError: false
      }
    }

    case FETCH_CUSTOMERS_SUCCESS: {
      return {
        ...state,
        customers: action.payload,
        loadingCustomers: false,
        loadingCustomersError: false
      }
    }

    case FETCH_CUSTOMERS_FAIL: {
      return {
        ...state,
        loadingCustomers: false,
        loadingCustomersError: true
      }
    }

      /***********************************
       * ADD_CUSTOMER
       ***********************************/

    case ADD_CUSTOMER: {
      return {
        ...state,
        addingCustomerError: false
      }
    }

    case ADD_CUSTOMER_SUCCESS: {
      // {
      //   "CustomerId": "258929701",
      //     "CustomerName": "Bluth Company, Inc.",
      //     "CustomerDomains": "bluth.com, bluth.co",
      //     "CustomerIpAddresses": "www.bluth.co",
      //     "ServiceRequested": 4,
      //     "Comments": "CIRT Premium - Small",
      //     "CustomerPocName": "Michael Bluth",
      //     "CustomerPocEmail": "itsupport@bluth.co",
      //     "CustomerPocPhone": "832-123-4567",
      //     "CreatedDate": "2020-08-29 14:22:19.495820",
      //     "StatusId": 0
      // }
      const newCustomersState = {...state.customers};
      try {
        // console.log("Updating stromboli local state with the following payload", action.payload);
        const customerIdToUpdate = action.payload.inboundData.CustomerId;
        const newName = action.payload.inboundData.CustomerName;
        //console.log("copied the customer state into newCustomersState:", newCustomersState);
        // console.log("About to modify the Stromboli of", newCustomersState[customerIdToUpdate], "To have a status of ", newStromboliStatus);
        newCustomersState[customerIdToUpdate] = action.payload.inboundData;
        showBBNotification(SUCCESS, "New Customer", `${newName} added with ID ${customerIdToUpdate}`);
        return {
          ...state,
          addingCustomerError: false,
          customers: newCustomersState,
        }
      } catch (error) {
        showBBNotification(DANGER, "Error Adding new Customer", `Could not update the local state. Please reload this page and try again.  If this issue persists, please contact support.`);
        console.error(error);
        return {
          ...state,
          addingCustomerError: true,
        }
      }
    }

    case ADD_CUSTOMER_FAIL: {
      return {
        ...state,
        addingCustomerError: true
      }
    }

    /***********************************
     * SET_STROMBOLI
     ***********************************/

    case SET_STROMBOLI_OFF:
    case SET_STROMBOLI_ON: {
      return {
        ...state,
        loadingStromboli: true,
      }
    }

    case SET_STROMBOLI_OFF_SUCCESS:
    case SET_STROMBOLI_ON_SUCCESS: {
      const newCustomersState = {...state.customers};
      try {
        // console.log("Updating stromboli local state with the following payload", action.payload);
        const customerIdToUpdate = action.payload.CustomerId;
        const newStromboliStatus = action.payload["Service Active"];
        //console.log("copied the customer state into newCustomersState:", newCustomersState);
        // console.log("About to modify the Stromboli of", newCustomersState[customerIdToUpdate], "To have a status of ", newStromboliStatus);
        newCustomersState[customerIdToUpdate].Stromboli["Service Active"] = newStromboliStatus;
      } catch (error) {
        showBBNotification(DANGER, "Error Starting Attacks", `Could not update the local state. Please reload this page and try again.  If this issue persists, please contact support.`);
        console.error(error);
        return {
          ...state,
          loadingStromboli: false,
          loadingStromboliError: false,
        }
      }

      return {
        ...state,
        loadingStromboli: false,
        loadingStromboliError: false,
        customers: newCustomersState,

      }
    }

    case SET_STROMBOLI_OFF_FAIL:
    case SET_STROMBOLI_ON_FAIL: {
      return {
        ...state,

        loadingStromboli: false,
        loadingStromboliError: true

      }
    }

    /***********************************
     * FETCH_TARGETS
     ***********************************/

    case FETCH_TARGETS: {
      if (!!action.payload.silentLoading && action.payload.silentLoading === true) {
        //this is a behind the scenes, don't update loading state
        return {
          ...state,
          // loadingTargets: true,
          // loadingTargetsError: false
        }
      } else {
        return {
          ...state,
          loadingTargets: true,
          loadingTargetsError: false
        }
      }

    }

      // Target Summary
    case FETCH_TARGETS_SUCCESS: {
      // console.log("FETCH_TARGETS_SUCCESS reducer is in action...");
      // console.log("action.payload.inboundData is", action.payload.inboundData);
      // console.log("action.payload.inboundMeta is", action.payload.inboundMeta);
      if (action.payload.customerId && state.customers && state.customers[action.payload.customerId]) {
        //carefully place the targets summary data into the data tree
        // console.log(`Attempting to update the state for targets of ${action.payload.customerId}, using this payload data:`, action.payload);
        return {
          ...state,
          customers: {
            ...state.customers, //don't change other customers
            [action.payload.customerId] : { //change customer with given id
              ...state.customers[action.payload.customerId], //don't change other data within this customer
              targets: {
                ...state.customers[action.payload.customerId].targets,
                ...action.payload.inboundData
              } //add/overwrite the new target summary data
            }
          },
          loadingTargets: false,
          loadingTargetsError: false,
          //update the totals
          metaTargets: {
            ...state.metaTargets,
            [action.payload.customerId] : action.payload.inboundMeta ? action.payload.inboundMeta : state.metaTargets[action.payload.customerId]
          }
        }
      }
      else {
        // console.log(`Attempted to update the state for targets of ${action.payload}, but nulls and stuff.`);
        //targets already exists, so don't update the data
        return {
          ...state,
          //stop the loaders
          loadingTargets: false,
          loadingTargetsError: false
        }
      }
    }

    case FETCH_TARGETS_FAIL: {
      return {
        ...state,
        loadingTargets: false,
        loadingTargetsError: true
      }
    }


    /***********************************
     * FETCH_TARGET
     ***********************************/

      // Single Target
    case FETCH_TARGET_SUCCESS: {
      // console.log("FETCH_TARGETS_SUCCESS reducer is in action...");
      if (action.payload.customerId && state.customers && state.customers[action.payload.customerId]) {
        //carefully place the targets summary data into the data tree
        // console.log(`Attempting to update the state for targets of ${action.payload.customerId}, using this payload data:`, action.payload);
        // console.log("Here is the store: ", state);
        return {
          ...state,
          customers: {
            ...state.customers, //don't change other customers
            [action.payload.customerId]: { //change customer with given id
              ...state.customers[action.payload.customerId], //don't change other data within this customer
              targets: {
              ...state.customers[action.payload.customerId].targets,
              [action.payload.targetId] : action.payload.target //add/overwrite the new target detailed data
              }
          },
      },
          // loadingTargets: false,
          // loadingTargetsError: false
        }
      }
      break;
    }

      /***********************************
       * SET_TARGET_SCOPE
       ***********************************/

    case SET_TARGET_SCOPE: {
      return {
        ...state,
          scopeTogglesLoading: {
          ...state.scopeTogglesLoading,
                [action.payload.customerId] : {
              ...state.scopeTogglesLoading[action.payload.customerId],
                  [action.payload.targetId]: true,
          }
          },
          scopeTogglesFail: {
          ...state.scopeTogglesFail,
                [action.payload.customerId] : {
                  ...state.scopeTogglesFail[action.payload.customerId],
                  [action.payload.targetId]: false,
                }
          }
        }
      }

      // Single Target
    case SET_TARGET_SCOPE_SUCCESS: {
      console.log("FETCH_TARGETS_SUCCESS reducer is in action...", action.payload);
      const addThisToTargets_OOS = action.payload.inboundData["OutOfScope"] === "1" ? 1 : -1;
      if (action.payload.customerId && state.customers && state.customers[action.payload.customerId]) {
        return {
          ...state,
          customers: {
            ...state.customers, //don't change other customers
            [action.payload.customerId]: { //change customer with given id
              ...state.customers[action.payload.customerId], //don't change other data within this customer
              targets: {
                ...state.customers[action.payload.customerId].targets,
                [action.payload.targetId]: action.payload.inboundData //add/overwrite the new target detailed data
              }
            },
          },
          scopeTogglesLoading: {
            ...state.scopeTogglesLoading,
            [action.payload.customerId]: {
              ...state.scopeTogglesLoading[action.payload.customerId],
              [action.payload.targetId]: false,
            }

          },
          scopeTogglesFail: {
            ...state.scopeTogglesFail,
            [action.payload.customerId]: {
              ...state.scopeTogglesFail[action.payload.customerId],
              [action.payload.targetId]: false,
            }
          },
          //update the local metadata in metaTargets targets_oos
          metaTargets: {
            ...state.metaTargets,
            [action.payload.customerId] : {
              ...state.metaTargets[action.payload.customerId],
              targets_oos: state.metaTargets[action.payload.customerId]["targets_oos"] + addThisToTargets_OOS
            }
          }

        }
      } else {
        return {
          ...state,
          scopeTogglesLoading: {
            ...state.scopeTogglesLoading,
            [action.payload.customerId] : {
              ...state.scopeTogglesLoading[action.payload.customerId],
              [action.payload.targetId]: false,
            }
          },
          scopeTogglesFail: {
            ...state.scopeTogglesFail,
            [action.payload.customerId] : {
              ...state.scopeTogglesFail[action.payload.customerId],
              [action.payload.targetId]: true,
            }
          }
        }
      }
    }

    case SET_TARGET_SCOPE_FAIL: {
      return {
        ...state,
        scopeTogglesLoading: {
          ...state.scopeTogglesLoading,
          [action.payload.customerId] : {
            ...state.scopeTogglesLoading[action.payload.customerId],
            [action.payload.targetId]: false,
          }
        },
        scopeTogglesFail: {
          ...state.scopeTogglesFail,
          [action.payload.customerId] : {
            ...state.scopeTogglesFail[action.payload.customerId],
            [action.payload.targetId]: true,
          }
        }

      }
    }

    /***********************************
     * FETCH_EVENTS
     ***********************************/

    case FETCH_EVENTS: {
      return {
        ...state,
        loadingEvents: true,
        loadingEventsError: false
      }
    }

      // Events... slice in to by .... ? in first version, will map to an id number that represents the range start/range end.
    case FETCH_EVENTS_SUCCESS: {
      // console.log("FETCH_EVENTS_SUCCESS reducer is in action...");
      if (action.payload.customerId && state.customers && state.customers[action.payload.customerId]) {
        // console.log(`Attempting to update the state for events of ${action.payload.customerId}, using this payload data: `, action.payload);

          //build a branch of the state tree where items are given an Id based on the rangeStart and rangeEnd

        // EXAMPLE EVENT DATA AS OF DEC 18 2020 inbound data will be the value of the "events" object.
        //   {
        //     "events": {
        //     "5d25c5be-69e9-40c9-b377-eda35e779099": {
        //       "Id": "5d25c5be-69e9-40c9-b377-eda35e779099",
        //           "Created DateTime": "2020-10-27 10:07:53.256050",
        //           "Event Type": {
        //         "Id": 49,
        //             "Name": "New Service Discovery Event",
        //             "Event Category": 2,
        //             "Description": "Event detailing the detection of a new active service for this target.",
        //             "Event Image Url": null
        //       },
        //       "Details": "{\"ServiceId\": \"5b3cd432-e91f-4ae0-a0e8-5aedaf78f047\", \"Port\": 443, \"Service\": \"https\"}",
        //           "Created By": 2,
        //           "TargetId": "dcf3d2106ca26ee70dbbf054789384aef5f4e4a6"
        //     },
        //     "4a173de6-bb1d-4f6b-87e2-d4183e34cbff": {
        //       "Id": "4a173de6-bb1d-4f6b-87e2-d4183e34cbff",
        //           "Created DateTime": "2020-10-27 10:17:32.515610",
        //           "Event Type": {
        //         "Id": 49,
        //             "Name": "New Service Discovery Event",
        //             "Event Category": 2,
        //             "Description": "Event detailing the detection of a new active service for this target.",
        //             "Event Image Url": null
        //       },
        //       "Details": "{\"ServiceId\": \"320b871b-aedb-4623-9673-852976170d61\", \"Port\": 80, \"Service\": \"http\"}",
        //           "Created By": 2,
        //           "TargetId": "dcf3d2106ca26ee70dbbf054789384aef5f4e4a6"
        //     },
        //   }
        //   }
        // CONCLUSION: just reassign the keys of the object to be an id number derrived from the rangestart and rangeend
        // results appear to be that events that occurred longer ago are at the top.  that means that the
        // last item will be the one that happens soonest.  so also need to reverse the order here.

        const inboundBranch = action.payload.inboundData;

        //build an array of numbers based on the start and end
        const batchSize = Number.parseInt(action.payload.inboundMeta.page_size);
        const pageNumber = Number.parseInt(action.payload.pageNumber);
        const rangeOfIds = [];
        const rangeStart = pageNumber * batchSize - batchSize;
        const rangeEnd = pageNumber * batchSize - 1;
        for (let i = rangeStart; i <= rangeEnd; i++) {
          rangeOfIds.push(i);
        }

        if(rangeOfIds.length > 0) {
          rangeOfIds.reverse();
        }

        //get an array of {serialId : inboundBranchObject}
        let serialObjectPairsArray = Object.keys(inboundBranch).length <= 0
            ? null
            : Object.keys(inboundBranch).map((key) => {
              return { [rangeOfIds.pop()] : inboundBranch[key] };
              });

        //transform array from last step into an object
        const newBranch = serialObjectPairsArray ? serialObjectPairsArray.reduce((a, b) => Object.assign({}, a, b)): [];

        // console.log("Transformed the events data from: ", inboundBranch, "to ", newBranch, "using rangeStart ", rangeStart, "and rangeEnd ", rangeEnd, " serialObjectPairsArray", serialObjectPairsArray);

        return {
          ...state,
          customers: {
            ...state.customers, //don't change other customers
            [action.payload.customerId] : { //change customer with given id
              ...state.customers[action.payload.customerId], //don't change other data within this customer
              events: {
                ...state.customers[action.payload.customerId].events, //keep event data already collected
                ...newBranch,
              }
            }
          },
          loadingEvents: false,
          loadingEventsError: false,
          //update the totals
          metaEvents: {
            ...state.metaEvents,
            [action.payload.customerId] : action.payload.inboundMeta
          }
        }
      }
      else {
        console.log(`Attempted to update the state for events of ${action.payload}, but nulls and stuff.`);
        return {
          ...state,
          //stop the loaders
          loadingEvents: false,
          loadingEventsError: false
        }
      }
    }

    case FETCH_EVENTS_FAIL: {
      return {
        ...state,
        loadingEvents: false,
        loadingEventsError: true
      }
    }

    /***********************************
     * FETCH_VECTORS
     ***********************************/

    case FETCH_VECTORS: {
      return {
        ...state,
        loadingVectors: true,
        loadingVectorsError: false
      }
    }

      // Vectors Summary
    case FETCH_VECTORS_SUCCESS: {
      // console.log("FETCH_VECTORS_SUCCESS reducer is in action...");
      if (action.payload.customerId && state.customers && state.customers[action.payload.customerId]) {

        //peel out the target data sent with this
        const collateralTargets = {}
        for(const key of Object.keys(action.payload.inboundData)) {
          // console.log("looking for key ", key, "in action.payload.inboundData", action.payload.inboundData)
          collateralTargets[action.payload.inboundData[key].TargetId] = action.payload.inboundData[key]["Target Details"]
        }

        // console.log("FETCH_VECTORS_SUCCESS got some new collateral target data from a vectors call: ", collateralTargets)

        //carefully place the targets summary data into the data tree
        // console.log(`Attempting to update the state for targets of ${action.payload.customerId}, using this payload data: ${action.payload}`);
        return {
          ...state,
          customers: {
            ...state.customers, //don't change other customers
            [action.payload.customerId] : { //change customer with given id
              ...state.customers[action.payload.customerId], //don't change other data within this customer
              vectors: action.payload.inboundData, //add/overwrite the new target summary data,
              //also add the target data that comes with
              targets : {
                ...state.customers[action.payload.customerId].targets,
                ...collateralTargets
              }
            }
          },
          loadingVectors: false,
          loadingVectorsError: false,
          //update the totals
          // metaAttacks: {
          //   ...state.metaAttacks,
          //   [action.payload.customerId] : action.payload.inboundMeta
          // }
        }

      } else {
        // console.log(`Attempted to update the state for vectors of ${action.payload}, but nullz.`);
        return {
          ...state,
          //stop the loaders
          loadingVectors: false,
          loadingVectorsError: false
        }
      }
    }

    case FETCH_VECTORS_FAIL: {
      return {
        ...state,
        loadingVectors: false,
        loadingVectorsError: true
      }
    }

    /***********************************
     * FETCH_ATTACKS
     ***********************************/

    case FETCH_ATTACKS: {
      return {
        ...state,
        loadingAttacks: true,
        loadingAttacksError: false
      }
    }

      // Attacks Summary
    case FETCH_ATTACKS_SUCCESS: {
       console.log("FETCH_ATTACKS_SUCCESS reducer is in action...");
      if (action.payload.customerId && state.customers && state.customers[action.payload.customerId]) {

        //attacks are all associated with a vector

        // console.log(`Attempting to update the state for attacks of ${action.payload.customerId}, using this payload data:`, action.payload);
        // console.log("Pre-update state of state.customers[action.payload.customerId].vectors ", state.customers[action.payload.customerId].vectors)
        // console.log("Going to put this in Attacks:  ...action.payload.inboundData", action.payload.inboundData);
        // console.log("Here is metaAttacks", state.metaAttacks, "putting this in there at customer: ", [action.payload.customerId], "meta data:", action.payload.inboundMeta)

        //before placing in the data, look for data that already exists.  if that data is a "detailed" attack, don't replace it
        const inboundAttacks = action.payload.inboundData
        const inboundAttackIds = Object.keys(inboundAttacks);
        const oldAttacks = state.customers[action.payload.customerId].vectors[action.payload.vectorId].Attacks;
        const oldStateAttackIds = Object.keys(oldAttacks)

        const attackIdsToOverwrite = inboundAttackIds.filter((item) => {
          //if the old state attack exists, and that attack has a property called Events, it is a detiled attack, so filter out
          return !(oldStateAttackIds.includes(item)
              && (oldAttacks[item].hasOwnProperty("Events")
                || oldAttacks[item].hasOwnProperty("Perimeter Attack Detail")
                || oldAttacks[item].hasOwnProperty("Phishing Attack Detail"))
              );
        })
        console.log("Planning to overwrite these attacks", attackIdsToOverwrite, "from oldAttacks", oldAttacks)

        const summaryAttacks = filterObject(inboundAttacks, (inboundAttackKey, inboundAttack) => attackIdsToOverwrite.includes(inboundAttackKey));
        console.log("summaryAttacks", summaryAttacks)

        return {
          ...state,
          customers: {
            ...state.customers, //don't change other customers
            [action.payload.customerId] : { //change customer with given id
              ...state.customers[action.payload.customerId], //don't change other data within this customer
              vectors: {
                ...state.customers[action.payload.customerId].vectors,
                [action.payload.vectorId] : {
                  ...state.customers[action.payload.customerId].vectors[action.payload.vectorId],
                  Attacks : {
                    ...state.customers[action.payload.customerId].vectors[action.payload.vectorId].Attacks,
                    ...summaryAttacks
                  },
                  //overwrite the new target summary data,
                  ["Attack Totals"] : {
                    ...action.payload.inboundMeta
                  },
        }
              },

            }
          },
          loadingAttacks: false,
          loadingAttacksError: false

        }

      } else {
        // console.log(`Attempted to update the state for vectors of ${action.payload}, but nullz.`);
        return {
          ...state,
          //stop the loaders
          loadingAttacks: false,
          loadingAttacksError: false
        }
      }
    }

    case FETCH_ATTACKS_FAIL: {
      return {
        ...state,
        loadingAttacks: false,
        loadingAttacksError: true
      }
    }

      /***********************************
       * FETCH_ATTACK (a single attack for either a campaign or perimeter vector)
       ***********************************/

    case FETCH_ATTACK: {
      return {
        ...state,
        loadingAttack: true,
        loadingAttackError: false
      }
    }

      // Attack Detail
    case FETCH_ATTACK_SUCCESS: {
      // console.log("FETCH_ATTACK_SUCCESS reducer is in action...");
      if (action.payload.customerId && (action.payload.vectorId || action.payload.customerId) && state.customers && state.customers[action.payload.customerId]) {

        //attacks are all associated with a vector

        // console.log(`Attempting to update the state for attacks of ${action.payload.customerId}, using this payload data:`, action.payload);
        // console.log("Pre-update state of state.customers[action.payload.customerId].vectors ", state.customers[action.payload.customerId].vectors)
        // console.log("Going to put this in Attacks:  ...action.payload.inboundData", action.payload.inboundData);
        // console.log("Here is metaAttacks", state.metaAttacks, "putting this in there at customer: ", [action.payload.customerId], "meta data:", action.payload.inboundMeta)

        //if its a vector attack, will handle differently.
        //attempt to destructure vectorId
        const {vectorId} = action.payload;
        if (vectorId) {
          //it is a vector
          // console.log("inbound data designated for a vector")
          const attacksAlreadyThere = state.customers[action.payload.customerId].vectors[vectorId] ? state.customers[action.payload.customerId].vectors[vectorId].Attacks ? state.customers[action.payload.customerId].vectors[vectorId].Attacks : {} : {};

          return {
            ...state,
            customers: {
              ...state.customers, //don't change other customers
              [action.payload.customerId] : { //change customer with given id
                ...state.customers[action.payload.customerId], //don't change other data within this customer
                vectors: {
                  ...state.customers[action.payload.customerId].vectors,
                  [vectorId] : {
                    ...state.customers[action.payload.customerId].vectors[vectorId],
                    Attacks : {
                      ...attacksAlreadyThere,
                      [action.payload.attackId] : action.payload.inboundData
                    },
                  }
                },
              }
            },
            loadingAttack: false,
            loadingAttackError: false
          }
        } else {
          //it is a campaign's attack
          // console.log("inbound data designated for a campaign")
          const {campaignId} = action.payload;
          const attacksAlreadyThere = state.customers[action.payload.customerId].campaigns[campaignId] ? state.customers[action.payload.customerId].campaigns[campaignId].Attacks ? state.customers[action.payload.customerId].campaigns[campaignId].Attacks : {} : {};

          return {
            ...state,
            customers: {
              ...state.customers, //don't change other customers
              [action.payload.customerId] : { //change customer with given id
                ...state.customers[action.payload.customerId], //don't change other data within this customer
                campaigns: {
                  ...state.customers[action.payload.customerId].campaigns,
                  [campaignId] : {
                    ...state.customers[action.payload.customerId].campaigns[campaignId],
                    Attacks : {
                      ...attacksAlreadyThere,
                      [action.payload.attackId] : action.payload.inboundData
                    },
                  }
                },
              }
            },
            loadingAttack: false,
            loadingAttackError: false
          }
        }



      } else {
        // console.log(`Attempted to update the state for vectors of ${action.payload}, but nullz.`);
        return {
          ...state,
          loadingAttack: false,
          loadingAttackError: true
        }
      }
    }

    case FETCH_ATTACK_FAIL: {
      return {
        ...state,
        loadingAttack: false,
        loadingAttackError: true
      }
    }

    /***********************************
     * FETCH_PERIMETER_ATTACKS_META
     ***********************************/


    case FETCH_PERIMETER_ATTACKS_META: {
      return {
        ...state,
        loadingMetaAttacks: true,
        loadingMetaAttacksError: false
      }
    }
      // PerimeterAttacks Meta
    case FETCH_PERIMETER_ATTACKS_META_SUCCESS: {
      // console.log("FETCH_PERIMETER_ATTACKS_META_SUCCESS reducer is in action...");
      try {

        //attacks are all associated with a vector

        // console.log(`Attempting to update the state for attacks of ${action.payload.customerId}, using this payload data:`, action.payload);
        // console.log("Pre-update state of state.customers[action.payload.customerId].vectors ", state.customers[action.payload.customerId].vectors)
        // console.log("Going to put this in metaAttacks:  ...action.payload.inboundData", action.payload.inboundData);
        // console.log("Here is metaAttacks", state.metaAttacks, "putting this in there at customer: ", [action.payload.customerId], "meta data:", action.payload.inboundMeta)
        return {
          ...state,
          metaAttacks: {
            ...state.metaAttacks,
              [action.payload.customerId] : action.payload.inboundData
            },
          loadingMetaAttacks: false,
          loadingMetaAttacksError: false
        }

      } catch(e) { //TODO: Add this try catch pattern to all reducer cases?
        return {
          ...state,
          //stop the loaders
          loadingMetaAttacks: false,
          loadingMetaAttacksError: true
        }
      }
    }

    case FETCH_PERIMETER_ATTACKS_META_FAIL: {
      return {
        ...state,
        loadingMetaAttacks: false,
        loadingMetaAttacksError: true
      }
    }

    /***********************************
     * FETCH_CAMPAIGNS
     ***********************************/

    case FETCH_CAMPAIGNS: {
      return {
        ...state,
        loadingCampaigns: true,
        loadingCampaignsError: false
      }
    }

      // Vectors Summary
    case FETCH_CAMPAIGNS_SUCCESS: {
      // console.log("FETCH_VECTORS_SUCCESS reducer is in action...");
      if (action.payload.customerId && state.customers && state.customers[action.payload.customerId]) {

        //peel out the target data sent with this
        // const collateralTargets = {}
        // for(const key of Object.keys(action.payload.inboundData)) {
        //   // console.log("looking for key ", key, "in action.payload.inboundData", action.payload.inboundData)
        //   collateralTargets[action.payload.inboundData[key].TargetId] = action.payload.inboundData[key]["Target Details"]
        // }

        // console.log("FETCH_VECTORS_SUCCESS got some new collateral target data from a vectors call: ", collateralTargets)
        // TODO: Check for overwriting of detailed attacks
        return {
          ...state,
          customers: {
            ...state.customers, //don't change other customers
            [action.payload.customerId] : { //change customer with given id
              ...state.customers[action.payload.customerId], //don't change other data within this customer
              campaigns: action.payload.inboundData, //add/overwrite the new target summary data,
              //also add the target data that comes with
              // targets : {
              //   ...state.customers[action.payload.customerId].targets,
              //   ...collateralTargets
              // }
            }
          },
          loadingCampaigns: false,
          loadingCampaignsError: false,
          //update the totals
          metaCampaigns: {
            ...state.metaCampaigns,
            [action.payload.customerId] : action.payload.inboundMeta
          }
        }

      } else {
        // console.log(`Attempted to update the state for vectors of ${action.payload}, but nullz.`);
        return {
          ...state,
          //stop the loaders
          loadingCampaigns: false,
          loadingCampaignsError: true,
        }
      }
    }

    case FETCH_CAMPAIGNS_FAIL: {
      return {
        ...state,
        loadingCampaigns: false,
        loadingCampaignsError: true
      }
    }

    /***********************************
     * FETCH_HUMANS
     ***********************************/

    case FETCH_HUMANS: {
      return {
        ...state,
        loadingHumans: true,
        loadingHumansError: false
      }
    }

      // Humans summary
    case FETCH_HUMANS_SUCCESS: {
      // console.log("FETCH_HUMANS_SUCCESS reducer is in action...");
      if (action.payload.customerId && state.customers && state.customers[action.payload.customerId]) {
        // console.log(`Attempting to update the state for humans of ${action.payload.customerId}, using this payload data: ${action.payload}`, action.payload);
        return {
          ...state,
          customers: {
            ...state.customers, //don't change other customers
            [action.payload.customerId] : { //change customer with given id
              ...state.customers[action.payload.customerId], //don't change other data within this customer
              humans: action.payload.inboundData //add/overwrite the new human summary data
            }
          },
          loadingHumans: false,
          loadingHumansError: false
        }
      } else {
        //carefully place the humans summary data into the data tree
        return {
          ...state,
          //stop the loaders
          loadingHumans: false,
          loadingHumansError: false
        }
      }
    }

    case FETCH_HUMANS_FAIL: {
      return {
        ...state,
        loadingHumans: false,
        loadingHumansError: true
      }
    }



      /***********************************
       * ACTIVATE CUSTOMER MODULES
       ***********************************/

    case CUSTOMER_MODULE_ACTIVATE: {

      const customerId = action.payload.customerId;
      const moduleId = action.payload.moduleId;

      return {
        ...state,
        loadingCustomerModuleActivate: {
          ...state.loadingCustomerModuleActivate,
          [customerId] : {
            ...state.loadingCustomerModuleActivate[customerId],
            [moduleId] : true
          },
        },
        loadingCustomerModuleActivateFail: {
          ...state.loadingCustomerModuleActivateFail,
          [customerId] : {
            ...state.loadingCustomerModuleActivateFail[customerId],
            [moduleId] : false
          },
        },
      }
    }

    case CUSTOMER_MODULE_ACTIVATE_SUCCESS: {

      const customerId = action.payload.customerId;
      const moduleId = action.payload.moduleId;
      const inboundData = action.payload.inboundData;

      return {
        ...state,
        // add the returned attack object to the state
        customers: {
          ...state.customers,
          [customerId]: {
            ...state.customers[customerId],
            Modules : inboundData
          }
        },

        loadingCustomerModuleActivate: {
          ...state.loadingCustomerModuleActivate,
          [customerId] : {
            ...state.loadingCustomerModuleActivate[customerId],
            [moduleId] : false
          },
        },
        loadingCustomerModuleActivateFail: {
          ...state.loadingCustomerModuleActivateFail,
          [customerId] : {
            ...state.loadingCustomerModuleActivateFail[customerId],
            [moduleId] : false
          },
        },
      }
    }

    case CUSTOMER_MODULE_ACTIVATE_FAIL: {
      const customerId = action.payload.customerId;
      const moduleId = action.payload.moduleId;

      return {
        ...state,
        loadingCustomerModuleActivate: {
          ...state.loadingCustomerModuleActivate,
          [customerId] : {
            ...state.loadingCustomerModuleActivate[customerId],
            [moduleId] : false
          },
        },
        loadingCustomerModuleActivateFail: {
          ...state.loadingCustomerModuleActivateFail,
          [customerId] : {
            ...state.loadingCustomerModuleActivateFail[customerId],
            [moduleId] : true
          },
        },
      }
    }

      /***********************************
       * DEACTIVATE CUSTOMER MODULES
       ***********************************/

    case CUSTOMER_MODULE_DEACTIVATE: {

      const customerId = action.payload.customerId;
      const moduleId = action.payload.moduleId;

      return {
        ...state,
        loadingCustomerModuleDeactivate: {
          ...state.loadingCustomerModuleDeactivate,
          [customerId] : {
            ...state.loadingCustomerModuleDeactivate[customerId],
            [moduleId] : true
          },
        },
        loadingCustomerModuleDeactivateFail: {
          ...state.loadingCustomerModuleDeactivateFail,
          [customerId] : {
            ...state.loadingCustomerModuleDeactivateFail[customerId],
            [moduleId] : false
          },
        },
      }
    }

    case CUSTOMER_MODULE_DEACTIVATE_SUCCESS: {

      const customerId = action.payload.customerId;
      const moduleId = action.payload.moduleId;
      const inboundData = action.payload.inboundData;

      return {
        ...state,
        // add the returned attack object to the state
        customers: {
          ...state.customers,
          [customerId]: {
            ...state.customers[customerId],
            Modules : inboundData
          }
        },

        loadingCustomerModuleDeactivate: {
          ...state.loadingCustomerModuleDeactivate,
          [customerId] : {
            ...state.loadingCustomerModuleDeactivate[customerId],
            [moduleId] : false
          },
        },
        loadingCustomerModuleDeactivateFail: {
          ...state.loadingCustomerModuleDeactivateFail,
          [customerId] : {
            ...state.loadingCustomerModuleDeactivateFail[customerId],
            [moduleId] : false
          },
        },
      }
    }

    case CUSTOMER_MODULE_DEACTIVATE_FAIL: {
      const customerId = action.payload.customerId;
      const moduleId = action.payload.moduleId;

      return {
        ...state,
        loadingCustomerModuleDeactivate: {
          ...state.loadingCustomerModuleDeactivate,
          [customerId] : {
            ...state.loadingCustomerModuleDeactivate[customerId],
            [moduleId] : false
          },
        },
        loadingCustomerModuleDeactivateFail: {
          ...state.loadingCustomerModuleDeactivateFail,
          [customerId] : {
            ...state.loadingCustomerModuleDeactivateFail[customerId],
            [moduleId] : true
          },
        },
      }
    }

      /***********************************
       * ACTIVATE CUSTOMER SUBSCRIPTIONS
       ***********************************/

    case CUSTOMER_SUBSCRIPTION_ACTIVATE: {

      const customerId = action.payload.customerId;
      // const moduleId = action.payload.moduleId;

      return {
        ...state,
        loadingCustomerSubscriptionActivate: {
          ...state.loadingCustomerSubscriptionActivate,
          [customerId] : true
        },
        loadingCustomerSubscriptionActivateFail: {
          ...state.loadingCustomerSubscriptionActivateFail,
          [customerId] : false
        },
      }
    }

    case CUSTOMER_SUBSCRIPTION_ACTIVATE_SUCCESS: {

      const customerId = action.payload.customerId;
      // const moduleId = action.payload.moduleId;
      // const inboundData = action.payload.inboundData;

      return {
        ...state,
        // add the returned attack object to the state
        customers: {
          ...state.customers,
          [customerId]: {
            ...state.customers[customerId],
            ["Subscription Active"] : true
          }
        },

        loadingCustomerSubscriptionActivate: {
          ...state.loadingCustomerSubscriptionActivate,
          [customerId] : false
        },
        loadingCustomerSubscriptionActivateFail: {
          ...state.loadingCustomerSubscriptionActivateFail,
          [customerId] : false
        },
      }
    }

    case CUSTOMER_SUBSCRIPTION_ACTIVATE_FAIL: {
      const customerId = action.payload.customerId;
      // const moduleId = action.payload.moduleId;

      return {
        ...state,
        loadingCustomerSubscriptionActivate: {
          ...state.loadingCustomerSubscriptionActivate,
          [customerId] : false
        },
        loadingCustomerSubscriptionActivateFail: {
          ...state.loadingCustomerSubscriptionActivateFail,
          [customerId] : true
        },
      }
    }

      /***********************************
       * DEACTIVATE CUSTOMER SUBSCRIPTION
       ***********************************/

    case CUSTOMER_SUBSCRIPTION_DEACTIVATE: {

      const customerId = action.payload.customerId;
      // const moduleId = action.payload.moduleId;

      return {
        ...state,
        loadingCustomerSubscriptionDeactivate: {
          ...state.loadingCustomerSubscriptionDeactivate,
          [customerId] : true
        },
        loadingCustomerSubscriptionDeactivateFail: {
          ...state.loadingCustomerSubscriptionDeactivateFail,
          [customerId] : false
        },
      }
    }

    case CUSTOMER_SUBSCRIPTION_DEACTIVATE_SUCCESS: {

      const customerId = action.payload.customerId;
      // const moduleId = action.payload.moduleId;
      // const inboundData = action.payload.inboundData;

      return {
        ...state,
        // add the returned attack object to the state
        customers: {
          ...state.customers,
          [customerId]: {
            ...state.customers[customerId],
            ["Subscription Active"] : false
          }
        },

        loadingCustomerSubscriptionDeactivate: {
          ...state.loadingCustomerSubscriptionDeactivate,
          [customerId] : false
        },
        loadingCustomerSubscriptionDeactivateFail: {
          ...state.loadingCustomerSubscriptionDeactivateFail,
          [customerId] : false
        },
      }
    }

    case CUSTOMER_SUBSCRIPTION_DEACTIVATE_FAIL: {
      const customerId = action.payload.customerId;
      // const moduleId = action.payload.moduleId;

      return {
        ...state,
        loadingCustomerSubscriptionDeactivate: {
          ...state.loadingCustomerSubscriptionDeactivate,
          [customerId] : false
        },
        loadingCustomerSubscriptionDeactivateFail: {
          ...state.loadingCustomerSubscriptionDeactivateFail,
          [customerId] : true
        },
      }
    }


      /***************************************************************
       * **************** These are for BreachRisk *******************
       * *************************************************************/

      /***********************************
       * ADD_BR_SUBSCRIPTION
       ***********************************/

    case ADD_BR_SUBSCRIPTION: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRSubscription: {
          ...state.loadingAddBRSubscription,
          [customerId] : true,
        },
        loadingAddBRSubscriptionError: {
          ...state.loadingAddBRSubscriptionError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewBRSubscription: null
        },
      }
    }

    case ADD_BR_SUBSCRIPTION_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRSubscriptionData = action.payload.inboundData
      const newSubscriptionId = newBRSubscriptionData.id

      console.log("About to add a subscription for customerId", customerId, state.customers[customerId].Subscriptions);
      // const newSubscriptionsArray = state.customers[customerId].Subscriptions.push(newBRSubscriptionData);

      // console.log("ADD_BR_SUBSCRIPTION_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRSubscriptionsData, "for these entities", entities, "for this entityId", entityId);

      return {
        ...state,

        customers: {
          ...state.customers,
          [customerId]: {
            ...state.customers[customerId],
            Subscriptions : {
              ...state.customers[customerId].Subscriptions,
              [newSubscriptionId]: newBRSubscriptionData
            }
          }
        },

        loadingAddBRSubscription: {
          ...state.loadingAddBRSubscription,
          [customerId] : false,
        },
        loadingAddBRSubscriptionError: {
          ...state.loadingAddBRSubscriptionError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewBRSubscription: true
        },
      }
    }

    case ADD_BR_SUBSCRIPTION_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRSubscription: {
          ...state.loadingAddBRSubscription,
          [customerId] : false,
        },
        loadingAddBRSubscriptionError: {
          ...state.loadingAddBRSubscriptionError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewBRSubscription: false
        },
      }
    }

      /***********************************
       * UPDATE_BR_SUBSCRIPTION
       ***********************************/

    case UPDATE_BR_SUBSCRIPTION: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRSubscription: {
          ...state.loadingUpdateBRSubscription,
          [customerId] : true,
        },
        loadingUpdateBRSubscriptionError: {
          ...state.loadingUpdateBRSubscriptionError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustUpdateBRSubscription: null
        },
      }
    }

    case UPDATE_BR_SUBSCRIPTION_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRSubscriptionData = action.payload.inboundData
      const newSubscriptionId = newBRSubscriptionData.id

      console.log("About to update subscription a for customerId", customerId, state.customers[customerId].Subscriptions);
      // const newSubscriptionsArray = state.customers[customerId].Subscriptions.push(newBRSubscriptionData);

      // console.log("UPDATE_BR_SUBSCRIPTION_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRSubscriptionsData, "for these entities", entities, "for this entityId", entityId);

      return {
        ...state,

        customers: {
          ...state.customers,
          [customerId]: {
            ...state.customers[customerId],
            Subscriptions : {
              ...state.customers[customerId].Subscriptions,
              [newSubscriptionId]: newBRSubscriptionData
            }
          }
        },

        loadingUpdateBRSubscription: {
          ...state.loadingUpdateBRSubscription,
          [customerId] : false,
        },
        loadingUpdateBRSubscriptionError: {
          ...state.loadingUpdateBRSubscriptionError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustUpdateBRSubscription: true
        },
      }
    }

    case UPDATE_BR_SUBSCRIPTION_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRSubscription: {
          ...state.loadingUpdateBRSubscription,
          [customerId] : false,
        },
        loadingUpdateBRSubscriptionError: {
          ...state.loadingUpdateBRSubscriptionError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustUpdateBRSubscription: false
        },
      }
    }

//       /***********************************
//        * FETCH_SUBSCRIPTION
//        ***********************************/
// **MOVING TO ADMIN AND OUT OF CUSTOMER OBJECTR -- 14/9/2022
//     case FETCH_BR_SUBSCRIPTION: {
//       return{
//         ...state,
//         loadingSubscriptions: true,
//         errorLoadingSubscriptions: false,
//       }
//     }
//
//     case FETCH_BR_SUBSCRIPTION_SUCCESS: {
//
//       const customerId = action.payload.customerId;
//       const newSubscriptionsObj = action.payload.inboundData && action.payload.inboundData.subscriptions;
//
//       return{
//         ...state,
//         customers: {
//           ...state.customers,
//           [customerId]: {
//             ...state.customers[customerId],
//             subscriptionInfo: newSubscriptionsObj,
//           },
//         },
//         loadingSubscriptions: false,
//         errorLoadingSubscriptions: false,
//       }
//     }
//
//     case FETCH_BR_SUBSCRIPTION_FAIL: {
//       return{
//         ...state,
//         loadingSubscriptions: false,
//         errorLoadingSubscriptions: true,
//       };
//     }

      /***********************************
       * ADD_TAG FOR CUSTOMERS
       ***********************************/

    case ADD_TAG_CUSTOMER_SUCCESS : {
      const customerId = action.payload.customerId
      const affectedElementId = action.payload.affectedElementId
      const newTagData = action.payload.inboundData

      console.log("Adding a new successful Tag to Local State tree.",customerId, affectedElementId, newTagData);

      const newCustomerTags = state
      && state.customers
      && state.customers[customerId]
      && state.customers[customerId].Tags
        ? {
        ...state.customers[customerId].Tags,
            [newTagData.id] : newTagData
          }
          : null;

      console.log("Calculated new customerTags by adding", newTagData, "Final tag sate:", newCustomerTags);

      const newCustomers = {
        ...state.customers,
        [customerId] : {
          ...state.customers[customerId],
          Tags: newCustomerTags ? newCustomerTags : state.customers[customerId].Tags
        }
      }

      return{
        ...state,
        customers: newCustomers
        }

    }

    case ADD_TAG_CUSTOMER_FAIL: {
      return{
        ...state,
      }
    }

      /***********************************
       * UPDATE_TAG FOR CUSTOMERS
       ***********************************/

    case UPDATE_TAG_CUSTOMER_SUCCESS: {
      const customerId = action.payload.customerId
      const affectedElementId = action.payload.affectedElementId
      const newTagData = action.payload.inboundData
      const tagId = action.payload.tagId

      console.log("Updating a customer Tag to Local State tree.",customerId, affectedElementId, newTagData);

      const newCustomers = {
        ...state.customers,
        [customerId] : {
          ...state.customers[customerId],
          Tags: {
            ...state.customers[customerId].Tags,
            [tagId] : newTagData
          }
        }
      }
      // return {
      //   ...state,
      //
      //   customers: {
      //     ...state.customers,
      //     [customerId]: {
      //       ...state.customers[customerId],
      //       Subscriptions : {
      //         ...state.customers[customerId].Subscriptions,
      //         [newSubscriptionId]: newBRSubscriptionData
      //       }
      //     }
      //   },

      return{
        ...state,
        customers: newCustomers
      }

    }

    case UPDATE_TAG_CUSTOMER_FAIL: {
      return{
        ...state
      }
    }

      /*  sarahp**********06.09.22*****
  *  Get Users for Customer
                   **********************  */
    case FETCH_USERS_FOR_CUSTOMER: {
      const customerId = action.payload.customerId

      return{
        ...state,
        loadingUsersForCustomer: {
          ...state.loadingUsersForCustomer,
          [customerId]:true,
        },
        loadingUserForCustomerError: {
          ...state.loadingUsersForCustomerError,
          [customerId]:false,
        }
      }
    }

    case FETCH_USERS_FOR_CUSTOMER_SUCCESS: {

      const customerId = action.payload.customerId
      const users = action.payload && action.payload.inboundData
          ? action.payload.inboundData
          : {}

      return{
        ...state,
        loadingUsersForCustomer: {
          ...state.loadingUsersForCustomer,
          [customerId]:false,
        },
        loadingUserForCustomerError: {
          ...state.loadingUsersForCustomerError,
          [customerId]:false,
        },
        customers: {
          ...state.customers,
          [customerId] : {
            ...state.customers[customerId],
            users: users,
          },
        },
      }
    }

    case FETCH_USERS_FOR_CUSTOMER_FAIL: {

      const customerId = action.payload.customerId


      return{
        ...state,
        loadingUsersForCustomer: {
          ...state.loadingUsersForCustomer,
          [customerId]:true,
        },
        loadingUserForCustomerError: {
          ...state.loadingUsersForCustomerError,
          [customerId]:true,
        },
        customers: {
          ...state.customers,
          [customerId] : {
            ...state.customers[customerId],
            users: {...state.customers[customerId].users},
          },
        },
      }
    }

      /*  sarahp**********06.09.22*****
   *  POST Users for Customer
       **********************  */

    case CREATE_USER_FOR_CUSTOMER: {
      const customerId = action.payload.customerId
      // const users = action.payload && action.payload.inboundData
      //     ? action.payload.inboundData
      //     : {}

      return {
        ...state,
        loadingCreateUserForCustomer: {
          ...state.loadingCreateUserForCustomer,
          [customerId]:true,
        },
        loadingCreateUserForCustomerError: {
          ...state.loadingCreateUserForCustomerError,
          [customerId]:false,
        },
        // users : users,
      }
    }

    case CREATE_USER_FOR_CUSTOMER_SUCCESS: {

      const customerId = action.payload.customerId
      const users = action.payload && action.payload.inboundData
          ? action.payload.inboundData
          : {}

      return {
        ...state,
        loadingCreateUserForCustomer: {
          ...state.loadingCreateUserForCustomer,
          [customerId]:false,
        },
        loadingCreateUserForCustomerError: {
          ...state.loadingCreateUserForCustomerError,
          [customerId]:false,
        },
        customers: {
          ...state.customers,
          [customerId] : {
            ...state.customers[customerId],
            users: users,
          },
        },
      }
    }

    case CREATE_USER_FOR_CUSTOMER_FAIL: {

      const customerId = action.payload.customerId

      return {
        ...state,
        loadingCreateUserForCustomer: {
          ...state.loadingCreateUserForCustomer,
          [customerId]:false,
        },
        loadingCreateUserForCustomerError: {
          ...state.loadingCreateUserForCustomerError,
          [customerId]:true,
        },
        // customers: {
        //   ...state.customers,
        //   [customerId] : {
        //     ...state.customers[customerId],
        //     users: {...state.customers[customerId].users},
        //   },
        // },
      }
    }

      /*  sarahp**********06.09.22*****
   *  DEL Users for Customer
       **********************  */

    case DELETE_USER_FOR_CUSTOMER: {
      const customerId = action.payload.customerId

      return{
        ...state,
        loadingDeleteUserForCustomer: {
          ...state.loadingDeleteUserForCustomer,
          [customerId]:true,
        },
        loadingDeleteUserForCustomerError: {
          ...state.loadingDeleteUserForCustomerError,
          [customerId]:false,
        },
      }
    }

    case DELETE_USER_FOR_CUSTOMER_SUCCESS: {
      const customerId = action.payload.customerId
      const users = action.payload && action.payload.inboundData
          ? action.payload.inboundData
          : {}
      return{
        ...state,
        loadingDeleteUserForCustomer: {
          ...state.loadingDeleteUserForCustomer,
          [customerId]:false,
        },
        loadingDeleteUserForCustomerError: {
          ...state.loadingDeleteUserForCustomerError,
          [customerId]:false,
        },
        customers: {
          ...state.customers,
          [customerId] : {
            ...state.customers[customerId],
            users: users,
          },
        },
      }
    }

    case DELETE_USER_FOR_CUSTOMER_FAIL: {
      const customerId = action.payload.customerId

      return{
        ...state,
        loadingDeleteUserForCustomer: {
          ...state.loadingDeleteUserForCustomer,
          [customerId]:false,
        },
        loadingDeleteUserForCustomerError: {
          ...state.loadingDeleteUserForCustomerError,
          [customerId]:true,
        },
        // customers: {
        //   ...state.customers,
        //   [customerId] : {
        //     ...state.customers[customerId],
        //     users: {...state.customers[customerId].users},
        //   },
        // },
      }
    }
      /*  sarahp**********12.09.22*****
   *  DEL Users for Customer-- INVITE ONLY
       **********************  */

    case DELETE_USER_FOR_CUSTOMER_INVITE: {

      const customerId = action.payload.customerId

      return{
        ...state,
        loadingDeleteUserForCustomer: {
          ...state.loadingDeleteUserForCustomer,
          [customerId]:true,
        },
        loadingDeleteUserForCustomerError: {
          ...state.loadingDeleteUserForCustomerError,
          [customerId]:false,
        },
      }
    }

    case DELETE_USER_FOR_CUSTOMER_INVITE_SUCCESS: {
      const customerId = action.payload.customerId
      const users = action.payload && action.payload.inboundData
          ? action.payload.inboundData
          : {}

      return{
        ...state,
        loadingDeleteUserForCustomer: {
          ...state.loadingDeleteUserForCustomer,
          [customerId]:false,
        },
        loadingDeleteUserForCustomerError: {
          ...state.loadingDeleteUserForCustomerError,
          [customerId]:false,
        },
        customers: {
          ...state.customers,
          [customerId] : {
            ...state.customers[customerId],
            users: users,
          },
        },
      }
    }

    case DELETE_USER_FOR_CUSTOMER_INVITE_FAIL: {
      const customerId = action.payload.customerId

      return{
        ...state,
        loadingDeleteUserForCustomer: {
          ...state.loadingDeleteUserForCustomer,
          [customerId]:true,
        },
        loadingDeleteUserForCustomerError: {
          ...state.loadingDeleteUserForCustomerError,
          [customerId]:false,
        },
        // customers: {
        //   ...state.customers,
        //   [customerId] : {
        //     ...state.customers[customerId],
        //     users: {...state.customers[customerId].users},
        //   },
        // },
      }
    }

      /***********************************
       * UPDATE_TAG FOR CUSTOMERS
       ***********************************/


    case UPDATE_CUSTOMER_NAME: {
      const customerId = action.payload.customerId;

      return{
        ...state,
        loadingUpdateCustomerName: {
          ...state.loadingUpdateCustomerName,
          [customerId]: true,
        },
        loadingUpdateCustomerNameError: {
          ...state.loadingUpdateCustomerNameError,
          [customerId]: false,
        },

      }

    }

    case UPDATE_CUSTOMER_NAME_SUCCESS: {
      const customerId = action.payload.customerId;
      const customerName = action.payload.customerName;
      const inboundData = action.payload.inboundData;

      console.log("UPDATE_CUSTOMER_NAME_SUCCESS, data looks like, customerId", customerId, "custoemrName", customerName, "inboundData", inboundData, )


      return{
        ...state,
        loadingUpdateCustomerName: {
          ...state.loadingUpdateCustomerName,
          [customerId]: false,
        },
        loadingUpdateCustomerNameError: {
          ...state.loadingUpdateCustomerNameError,
          [customerId]: false,
        },
        customers:{
          ...state.customers,
          [customerId]: {
            ...state.customers[customerId],
            CustomerName: customerName,

          }
        }


      }

    }

    case UPDATE_CUSTOMER_NAME_FAIL: {
      const customerId = action.payload.customerId;
      const customerName = action.payload.customerName;
      const inboundData = action.payload.inboundData;

      return{
        ...state,
        loadingUpdateCustomerName: {
          ...state.loadingUpdateCustomerName,
          [customerId]: false,
        },
        loadingUpdateCustomerNameError: {
          ...state.loadingUpdateCustomerNameError,
          [customerId]: true,
        },

      }

    }
    default:
      return state;
  }
}
